const routes = [
  {
    path: '/login',
    name: 'login',
    allowAnonymous: true,
    component: () => import(/* webpackChunkName: "home" */ '@/views/Login.vue'),
    meta: {
      title: 'KGB Aviation',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    allowAnonymous: true,
    component: () => import(/* webpackChunkName: "home" */ '@/views/Logout.vue'),
    meta: {
      title: 'KGB Aviation',
    },
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '@/views/Account.vue'),
    meta: {
      title: 'Account',
    },
  },
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: () => import(/* webpackChunkName: "updatePassword" */ '@/views/UpdatePassword.vue'),
    meta: {
      title: 'Update Password',
    },
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import(/* webpackChunkName: "devices" */ '@/views/Devices.vue'),
    meta: {
      title: 'Devices',
    },
  },
  {
    path: '/forgot',
    name: 'forgot',
    allowAnonymous: true,
    component: () => import(/* webpackChunkName: "forgot" */ '@/views/Forgot.vue'),
    meta: {
      title: 'Forgot Password',
    },
  },
  {
    path: '/reset/:token',
    name: 'reset',
    allowAnonymous: true,
    component: () => import('@/views/Reset'),
    meta: {
      title: 'Reset Password',
    },
  },
  {
    path: '/confirm/:token',
    name: 'confirm',
    allowAnonymous: true,
    component: () => import('@/views/ConfirmAccount'),
    meta: {
      title: 'Confirm Account',
    },
  },
  {
    path: '/organizations',
    name: 'organizations',
    component: () => import(/* webpackChunkName: "organizations" */ '@/views/Organizations.vue'),
    meta: {
      title: 'Organizations',
    },
  },
  {
    path: '/sites',
    name: 'sites',
    component: () => import(/* webpackChunkName: "sites" */ '@/views/Sites.vue'),
    meta: {
      title: 'Sites',
    },
  },
  {
    path: '/register',
    name: 'register',
    allowAnonymous: true,
    component: () => import(/* webpackChunkName: "register" */ '@/views/Register.vue'),
    meta: {
      title: 'Register Title',
    },
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
    meta: {
      title: 'Users',
    },
  },
  {
    path: '/reporting',
    name: 'reporting',
    component: () => import(/* webpackChunkName: "reporting" */ '@/views/Reporting.vue'),
    meta: {
      title: 'Reporting',
    },
  },
  {
    path: '/usage',
    name: 'usage',
    component: () => import(/* webpackChunkName: "usage" */ '@/views/Usage.vue'),
    meta: {
      title: 'Usage',
    },
  },
  {
    path: '/testResults',
    name: 'testResults',
    component: () => import(/* webpackChunkName: "testResults" */ '@/views/TestResults.vue'),
    meta: {
      title: 'Test Results',
    },
  },
  {
    path: '/management',
    name: 'management',
    component: () => import(/* webpackChunkName: "management" */ '@/views/Management.vue'),
    meta: {
      title: 'Management',
    },
  },
  {
    path: '/testFixtures',
    name: 'testFixtures',
    component: () => import(/* webpackChunkName: "testFixture" */ '@/views/TestFixture.vue'),
    meta: {
      title: 'Test Fixtures',
    },
  },
  {
    path: '/testFixtureResults',
    name: 'testFixtureResults',
    component: () => import(/* webpackChunkName: "testFixture" */ '@/views/TestFixtureResults.vue'),
    meta: {
      title: 'Cable Test Results',
    },
  },
  {
    path: '/programmaticAccess',
    name: 'programmaticAccess',
    component: () => import(/* webpackChunkName: "programmaticAccess" */ '@/views/ProgrammaticAccess.vue'),
    meta: {
      title: 'Programmatic Access',
    },
  },
  {
    path: '/apiDocumentation',
    name: 'apiDocumentation',
    component: () => import(/* webpackChunkName: "apiDocumentation" */ '@/views/ApiDocumentation.vue'),
    meta: {
      title: 'API Documentation',
    },
  },
];

export default routes;
